'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var react = _interopDefault(require('react'));
var propTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));

var jsx = function () {
  var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7;
  return function createRawReactElement(type, props, key, children) {
    var defaultProps = type && type.defaultProps;
    var childrenLength = arguments.length - 3;

    if (!props && childrenLength !== 0) {
      props = {};
    }

    if (props && defaultProps) {
      for (var propName in defaultProps) {
        if (props[propName] === void 0) {
          props[propName] = defaultProps[propName];
        }
      }
    } else if (!props) {
      props = defaultProps || {};
    }

    if (childrenLength === 1) {
      props.children = children;
    } else if (childrenLength > 1) {
      var childArray = Array(childrenLength);

      for (var i = 0; i < childrenLength; i++) {
        childArray[i] = arguments[i + 3];
      }

      props.children = childArray;
    }

    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type: type,
      key: key === undefined ? null : '' + key,
      ref: null,
      props: props,
      _owner: null
    };
  };
}();



















var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

























var taggedTemplateLiteral = function (strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var _templateObject=taggedTemplateLiteral(['\n  position: ',';\n  top: ',';\n  transform: ',';\n  transition: ',';\n  color: ',';\n  cursor: ',';\n  font-size: ',';\n'],['\n  position: ',';\n  top: ',';\n  transform: ',';\n  transition: ',';\n  color: ',';\n  cursor: ',';\n  font-size: ',';\n']);var transitionLabel=function(){var a=0<arguments.length&&arguments[0]!==void 0?arguments[0]:{},b=a.labelStyle,c=b===void 0?{}:b,d=a.disabled,e=a.active,f=_extends({position:'absolute',top:'50%',transform:'translateY(-50%)',transition:'200ms ease all',cursor:'text'},c);return d?_extends({},f,{color:'#e0e0e0',cursor:'default'},c):e?_extends({},f,{top:'0.4rem',transform:'none',fontSize:'0.75rem',color:'#a0a0a0'}):f};var StyledLabel=styled.label(_templateObject,function(a){return a.s.position||'initial'},function(a){return a.s.top||'initial'},function(a){return a.s.transform||'none'},function(a){return a.s.transition||'none'},function(a){return a.s.color||'#999'},function(a){return a.s.cursor||'auto'},function(a){return a.s.fontSize||'0.875rem'}); var Label=function(a){var b=a.className,c=a.s,d=a.children,e=a.id;return jsx(StyledLabel,{className:b,htmlFor:e,s:c},void 0,d)};Label.defaultProps={className:'',s:{},children:''};

exports.transitionLabel = transitionLabel;
exports['default'] = Label;
//# sourceMappingURL=index.js.map
